import { mc } from '@lss/common/game/characters/MC';
import { Phone, PHONE_BUTTONS } from '../../src/components/phoneUI/PhoneClass';
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import { TimageINT } from '../../src/store/slices/gameObjectSlice';
import { emily } from '../characters/Emily';
import { empty } from '../characters/empty';
import { checkCurrentImage, doWaitImageByTime } from '../helpers/helpers';
import { images } from "./images";
import { AfterVanessaVisit } from './V1';
import { V6EmilyRoomAfter } from './V6';

export const V6EmilysRoom = async (): Promise<any> => {

    return jump(V6EmilysRoomEnter, "V6EmilysRoomEnter");
};


export const V6EmilysRoomEnter = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyRoom_4, { transition: true });

    mc.think(`Let's see if I can find something.`);
    ImageClass.setImage(images.v6.EmilyRoom_6);
    mc.think(`There's her laptop...`);
    mc.think(`Oh, wait!`);
    ImageClass.setImage(images.v6.EmilyRoom_5);
    mc.think(`Jackpot!`);
    mc.think(`Fuck the laptop!`);
    mc.think(`She left her phone here!`);
    ImageClass.setImage(images.v6.EmilyRoom_7);
    mc.think(`Let's see what my ${emily.properties.relation} has been up to!`);


    return jump(V6EmilysPhone, "V6EmilysPhone");
};


export const V6EmilysPhone = async (): Promise<any> => {

    return jump(V6EmilysPics, "V6EmilysPics");
};


export const getEmilyPicByIndex = (index: number): TimageINT & { key: string; } => {
    switch (index) {
        case 0:
        default:
            return images.v6.EmilyPhone_0;
        case 1:
            return images.v6.EmilyPhone_1;
        case 2:
            return images.v6.EmilyPhone_3;
        case 3:
            return images.v6.EmilyPhone_2;



    }

};



// <!-- V -->
export const V6EmilysPics = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyRoom_7);
    if (empty.properties.counter == undefined) {
        await empty.set((properties) => {
            properties.counter = 0;
        });
    }
    const image = getEmilyPicByIndex(empty.properties.counter || 0);
    const phoneBtn = await Phone.open(image, async () => {


        if (!mc.properties.v6EmilyPhotosSeen?.includes(image.key) && checkCurrentImage(image, images.v6.EmilyPhone_0)) {

            Phone.talk({ character: mc.character, text: "Oh... I didn't know Emily is taking these kinds of selfies...", options: { think: true } });
            Phone.talk({ character: mc.character, text: "It's obviously not for me... I should think carefully if I want to keep flipping through those images.", options: { think: true } });

        } else if (!mc.properties.v6EmilyPhotosSeen?.includes(image.key) && checkCurrentImage(image, images.v6.EmilyPhone_1)) {

            Phone.talk({ character: mc.character, text: "She always had a pretty face, but this time she chose to show more...", options: { think: true } });
        } else if (!mc.properties.v6EmilyPhotosSeen?.includes(image.key) && checkCurrentImage(image, images.v6.EmilyPhone_3)) {

            Phone.talk({ character: mc.character, text: "Fuck... The pictures are getting more and more daring...\nI still have no clue who's getting them.", options: { think: true } });
        } else if (!mc.properties.v6EmilyPhotosSeen?.includes(image.key) && checkCurrentImage(image, images.v6.EmilyPhone_2)) {

            await mc.set((properties) => {
                properties.v6SawEmilyNudePhoto = true;
            });
            Phone.talk({ character: mc.character, text: "Fuck... She's completely nude...", options: { think: true } });
        } else {
            Phone.talk({ character: mc.character, text: "", options: { think: true, wait: false } });
        }

        let buttonList = Object.values(PHONE_BUTTONS);
        // most left image
        if (checkCurrentImage(image, images.v6.EmilyPhone_0)) {
            buttonList = buttonList.filter(btn => btn !== PHONE_BUTTONS.LEFT);

        }
        // most right image
        if (checkCurrentImage(image, images.v6.EmilyPhone_2)) {
            buttonList = buttonList.filter(btn => btn !== PHONE_BUTTONS.RIGHT);

        }

        Phone.setButtons(buttonList);


    });
    await mc.set((properties) => {
        properties.v6EmilyPhotosSeen?.push(image.key);
    });


    if (phoneBtn === PHONE_BUTTONS.RIGHT) {
        await empty.set((properties) => {
            if (properties.counter! < 3)
                properties.counter!++;
        });
    } else if (phoneBtn === PHONE_BUTTONS.LEFT) {
        await empty.set((properties) => {
            if (properties.counter! > 0) {
                properties.counter!--;
            }
        });
    } else if (phoneBtn === PHONE_BUTTONS.EXIT) {
        Phone.close(false);
        return jump(V6EmilysPicsAfter, "V6EmilysPicsAfter");
    }

    return jump(V6EmilysPics, "V6EmilysPics");
};

export const V6EmilysPicsAfter = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyRoom_7);
    mc.think(`Damn.`);
    mc.think(`I should get out of here before I'll come out as a creepy stalker.`);
    doWaitImageByTime(images.v6.MCRoom_0, { transition: true });
    mc.think(`That's something that will stay in my mind for a long time...`);
    return jump(V6EmilyRoomAfter, "V6EmilyRoomAfter");
};
